import { getConfiguration } from "./configuration";

export function filterByCustomizedState(elems) {
	const systemCode = getConfiguration().sys;
	const filteredElems = [];
	for (let ke in elems) {
		const elem = elems[ke];

		const keyMapSkinCode = systemCode;
		let keyMapGroupCode = null;
    	let keyMapShopCode = null;
		if (window.appConfig.TERMINAL_AGENCY) {
			const operator = window.getLoggedParamsFromLS();
			if (operator) {
				if (operator.groupId) {
					keyMapGroupCode = "GRP-" + operator.groupId;
				}
				const servicesMap = operator.servicesMap? operator.servicesMap: operator.hash_servizi;
				const cnPvend = servicesMap['SPORT'];
				if (cnPvend) {
					const cn = cnPvend.split("/")[0];
					const pvend = cnPvend.split("/")[1];
					keyMapShopCode = cn + "_" + pvend;
				}
			}
    	}
    	else if (window.appConfig.SELF_CASHIER) {
			const cashier = window.getVoucherParamsFromLS();
      		if (cashier) {
				if (cashier.groupId) {
					keyMapGroupCode = "GRP-" + cashier.groupId;
				}
				const servicesMap = cashier.servicesMap? cashier.servicesMap: cashier.hash_servizi;
				const cnPvend = servicesMap['SPORT'];
				if (cnPvend) {
					const cn = cnPvend.split("/")[0];
					const pvend = cnPvend.split("/")[1];
					keyMapShopCode = cn + "_" + pvend;
				}
			}
		}

		let stateCustom = null;
		const stateMap = elem.csm? elem.csm: {};
		//high priority: shop
		if (keyMapShopCode && stateMap[keyMapShopCode] !== null) {
    		stateCustom = stateMap[keyMapShopCode];
    	}
    	
	    // less priority: group of this shop
		if (keyMapGroupCode && stateMap[keyMapGroupCode] !== null && !stateCustom) {
			stateCustom = stateMap[keyMapGroupCode];
		}
		// lowest priority: skin customization
		if (stateMap[keyMapSkinCode] !== null && !stateCustom) {
			stateCustom = stateMap[keyMapSkinCode];
		}
				
		const loadIt = stateCustom !== 'CL';
		if (loadIt) {
			filteredElems.push(elem);
		}
	}
	
	return filteredElems;
}
